import React from 'react';
export function DemoSection() {
  return <section id="demo" className="py-20 bg-gray-50" data-id="element-157">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-160">
            See Newsfiliate in Action
          </h2>
          <p className="text-xl text-gray-600" data-id="element-161">
            Watch how easy it is to add Amazon deals to your Kit newsletter.
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-162">
          <div className="rounded-xl overflow-hidden shadow-xl" data-id="element-163">
            <div className="relative" style={{
            paddingBottom: '73.31975560081466%',
            height: 0
          }} data-id="element-164">
              <iframe src="https://www.loom.com/embed/310b5c5ca1774b548269e823c58938dc?sid=3a2accd0-6168-43d3-874b-3d0ee515114e" frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="Newsfiliate demo video" data-id="element-165" />
            </div>
          </div>
          <p className="text-center text-gray-500 mt-4" data-id="element-166">Watch the Quick Demo</p>
        </div>
      </div>
    </section>;
}